// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","FilterLinks__link":"ce_a bhl_h bhl_kh bhl_we bhl_su bhl_vt bhl_sw bhl_sn"};